
import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Button,
  Nav,
  NavItem,
  NavLink,
  Col,
  FormFeedback,
  Label,
} from "reactstrap";
import toast from "react-hot-toast";
import OrderSummary from "../Theme/DigitalMenuAI/Component/OrderSummary";
import OtpService from "../../Services/QRCodeServices/OtpService/OtpService";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { clearCart } from "../../slices/cart/CartSlice";
import OtpChangeReceiver from "./OtpChangeReceiver";
import GetContactInfoForm from "./GetContactInfoForm";
import GetOTPForm from "./GetOTPForm";

const OtpVerification = ({ isOpen, toggle, orgInfo }) => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.Cart.items);
  const [contactInfo, setContactInfo] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [countryCode, setCountryCode] = useState("+977");
  const [isOrderSummaryOpen, setIsOrderSummaryOpen] = useState(false);
  const { orgcode } = useParams();
  const hasPaymentOption = orgInfo?.organization?.hasPaymentOption || false;
  const hasSMSOption = orgInfo?.organization?.hasSMSOption || true;
  const [activeTab, setActiveTab] = useState(hasSMSOption ? "mobile" : "email");

  const handleContactSubmit = async () => {
    try {
      if (!contactInfo.trim()) {
        toast.error(
          `Please provide a valid ${activeTab === "mobile" ? "mobile number" : "email address"
          }`
        );
        return;
      }
      const isEmail = activeTab === "email"; // Determine if the active tab is email
      await OtpService.registerGuestUser({
        email: contactInfo,
        orgcode,
        isEmail, // Pass IsEmail as a boolean
      });
      setIsOtpSent(true);
      toast.success(
        `OTP sent successfully to your ${activeTab === "mobile" ? "mobile number" : "email"
        }!`
      );
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to send OTP");
      console.error("OTP sending error:", error);
    }
  };

  const handleOtpSubmit = async () => {
    try {
      const items = cartItems.map((item) => ({
        menuItemId: item.id,
        quantity: item.quantity,
      }));

      const postData = {
        [activeTab === "mobile" ? "phoneNumber" : "email"]: contactInfo,
        otp: otp,
        items,
      };

      const response = await OtpService.create({ orgcode, data: postData });
      toast.success("Your order has been submitted successfully");
      // dispatch(clearCart());
      if (!hasPaymentOption) {
        dispatch(clearCart());
      }
      toggle();
      setIsOrderSummaryOpen(true);

    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to submit order");
      console.error("Order submission error:", error);
    }
  };

  const handleResendOtp = async () => {
    try {
      const isEmail = activeTab === "email"; // Determine if the active tab is email
      await OtpService.registerGuestUser({
        email: contactInfo,
        orgcode,
        isEmail, // Pass IsEmail as a boolean
      });
      toast.success(
        `OTP resent successfully to your ${activeTab === "mobile" ? "mobile number" : "email"
        }!`
      );
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to resend OTP");
      console.error("OTP resend error:", error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setOtp("");
      setIsOtpSent(false);
      setContactInfo("");
      setCountryCode("+977");
    }
  }, [isOpen]);

  useEffect(() => {
    setOtp("");
    setIsOtpSent(false);
    setContactInfo("");
  }, [activeTab]);

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>Verification By</ModalHeader>
        <ModalBody>
          <Nav tabs className="mb-4">
            {hasSMSOption && (
              <NavItem>
                <NavLink
                  className={`cursor-pointer ${activeTab === "mobile" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("mobile")}
                >
                  Mobile Number
                </NavLink>
              </NavItem>
            )}
            <NavItem>
              <NavLink
                className={`cursor-pointer ${activeTab === "email" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("email")}
              >
                Email
              </NavLink>
            </NavItem>
          </Nav>

          <div className="mb-3">
            <label className="form-label">
              {activeTab === "mobile" ? "Mobile Number" : "Email Address"}
            </label>

            {isOtpSent && (
              <OtpChangeReceiver
                activeTab={activeTab}
                contactInfo={contactInfo}
                changeHandler={() => setIsOtpSent(false)} />
            )}
            {!isOtpSent && (
              <GetContactInfoForm
                hasSMSOption={hasSMSOption}
                activeTab={activeTab}
                contactInfo={contactInfo}
                setContactInfo={setContactInfo}
                countryCode={countryCode}
                setCountryCode={setCountryCode}
              />
            )}
          </div>

          {isOtpSent && (
            <GetOTPForm
              otp={otp}
              setOtp={setOtp}
              handleResendOtp={handleResendOtp}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" style={{ width: "100px" }} onClick={toggle}>
            Cancel
          </Button>
          <Button
            color="primary"
            style={{ width: "100px" }}
            onClick={isOtpSent ? handleOtpSubmit : handleContactSubmit}
          >
            {isOtpSent ? "Submit" : "Send"}
          </Button>
        </ModalFooter>
      </Modal>
      {hasPaymentOption && (
        <OrderSummary
          isOpen={isOrderSummaryOpen}
          toggle={() => setIsOrderSummaryOpen(false)}
        />
      )}
    </>
  );
};

export default OtpVerification;
